import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AsyncJob,
  ListAsyncJobItemsOptions,
  ListAsyncJobItemsResponse,
  getAsyncJob as universalGetAsyncJob,
  listAsyncJobItems as universalListAsyncJobItems,
} from './infra-asyncjobs-v1-async-job-async-jobs.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/async-jobs' };

export function getAsyncJob(httpClient: HttpClient): GetAsyncJobSignature {
  return (jobId: string) =>
    universalGetAsyncJob(
      jobId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetAsyncJobSignature {
  /**
   * Retrieves a job.
   * @param - Job ID.
   * @returns Returned job.
   */
  (jobId: string): Promise<
    NonNullablePaths<
      AsyncJob,
      | `_id`
      | `status`
      | `counters.itemsSucceeded`
      | `counters.itemsFailed`
      | `owner.anonymousVisitorId`
      | `owner.memberId`
      | `owner.wixUserId`
      | `owner.appId`
      | `owner.serviceId`
      | `createdBy.anonymousVisitorIdOptions.anonymousVisitorId`
      | `createdBy.memberIdOptions.memberId`
      | `createdBy.wixUserIdOptions.wixUserId`
      | `createdBy.appIdOptions.appId`
      | `createdBy.type`
      | `counts.successCount`
      | `counts.failCount`,
      2
    >
  >;
}

export function listAsyncJobItems(
  httpClient: HttpClient
): ListAsyncJobItemsSignature {
  return (jobId: string, options?: ListAsyncJobItemsOptions) =>
    universalListAsyncJobItems(
      jobId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface ListAsyncJobItemsSignature {
  /**
   * Retrieves a list of job items.
   * @param - Job ID.
   * @param - Field options.
   */
  (jobId: string, options?: ListAsyncJobItemsOptions): Promise<
    NonNullablePaths<
      ListAsyncJobItemsResponse,
      | `results`
      | `results.${number}._id`
      | `results.${number}.success`
      | `results.${number}.error.code`
      | `results.${number}.error.description`,
      3
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  AnonymousVisitorIdOptions,
  AppIdOptions,
  ApplicationError,
  AsyncJob,
  AsyncJobFailedEvent,
  AsyncJobFinishedEvent,
  AsyncJobItem,
  AsyncJobItemAddedEvent,
  AsyncJobItemFailedEvent,
  CompleteAsyncJobRequest,
  CompleteAsyncJobResponse,
  CompleteStatus,
  Counters,
  Counts,
  CreateAsyncJobRequest,
  CreateAsyncJobResponse,
  CreatedBy,
  CreatedByOptionsOneOf,
  CursorPaging,
  Cursors,
  DeleteAsyncJobRequest,
  DeleteAsyncJobResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  GetAsyncJobRequest,
  GetAsyncJobResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  ListAsyncJobItemsOptions,
  ListAsyncJobItemsRequest,
  ListAsyncJobItemsResponse,
  MemberIdOptions,
  MessageEnvelope,
  Owner,
  OwnerIdOneOf,
  PagingMetadataV2,
  ReportAsyncJobProgressRequest,
  ReportAsyncJobProgressResponse,
  RestoreInfo,
  Status,
  StatusFilter,
  Type,
  UpdateAsyncJobRequest,
  UpdateAsyncJobResponse,
  WebhookIdentityType,
  WixUserIdOptions,
} from './infra-asyncjobs-v1-async-job-async-jobs.universal.js';
